import {observer} from "mobx-react";
import {Linq, ScrollTable} from "../../ui";
import {useNavigate} from "react-router";
import {slsWarehouseListStore} from "../../../store";

const SlsWarehouseList = observer(function SlsWarehouseList() {
    const navigate = useNavigate()
    return <>
        <ScrollTable>
            <thead>
            <tr>
                <th>Name</th>
                <th>Nummer</th>
            </tr>
            </thead>
            <tbody>
            {slsWarehouseListStore.items.map((val, index) => {
                const link = `/sls/warehouse/${val.id}`
                return <tr key={index} style={{cursor: 'pointer'}} onClick={() => {
                    navigate(link)
                }}>
                    <td><Linq to={`${link}`}>{val.name}</Linq></td>
                    <td><Linq to={`${link}`}>{val.warehouseNumber}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
    </>
})

export {
    SlsWarehouseList
}
